export const ADD_COURIER_COMP_DETAILS = "ADD_COURIER_COMP_DETAILS";
export const FETCH_COURIER_COMP_DETAILS_LIST =
  "FETCH_COURIER_COMP_DETAILS_LIST";
export const EDIT_COURIER_COMP_DETAILS = "EDIT_COURIER_COMP_DETAILS";
export const UPDATE_COURIER_COMP_DETAILS = "UPDATE_COURIER_COMP_DETAILS";
export const DELETE_COURIER_COMP_DETAILS = "DELETE_COURIER_COMP_DETAILS";
